<!-- 合伙人协议 -->
<template>
  <van-dialog
    v-model="show"
    confirm-button-text="确定"
    className="bind-success"
    :beforeClose="beforeClose"
    @confirm="confirmModal"
    @cancel="cancel"
  >
    <div class="content">
      <div class="img-box">
        <img :src="bindImg" alt="">
      </div>
      <div class="title">绑定成功</div>
      <div class="auto">{{timeLimit}}s自动跳转</div>
    </div>
  </van-dialog>
</template>
<script>
import Cookie from 'js-cookie'
import bindImg from '@/assets/images/settle/bind.png'
export default {
  name: 'protocolModal',
  data() {
    return {
      show: false,
      timeLimit: 3,
      bindImg
    }
  },
  computed: {
    timeZone() {
      return this.timeLimit > 0 ? `(${this.timeLimit}s)` : ''
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.timeLimit = 3
        this.timer = setInterval(() => {
          --this.timeLimit
          if (this.timeLimit <= 0) {
            clearInterval(this.timer)
            this.confirmModal()
          }
        }, 1000)
      }
    }
  },

  methods: {
    // 取消的话 清除cookie
    cancel() {
      clearInterval(this.timer)
      if (Cookie.get('helper_tk')) {
        Cookie.remove('helper_tk')
      }
    },
    confirmModal() {
      this.$router.replace({
        path: '/addCard'
      })
    },
    beforeClose(action, done) {
      clearInterval(this.timer)
      done()
    }
  }
}
</script>

<style lang="less" scoped>
.bind-success {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  transform: none;
  border-radius: 0;
  box-sizing: border-box;
  background: #fff;
  .img-box{
    width: 155px;
    margin: 0 auto;
    margin-top: 180px;
    img{
      width: 100%;
      height: auto;
    }
  }
  .title{
    text-align: center;
    margin-top: 20px;
    color: #302B3E;
    font-size: 18px;
    font-weight: 600;
  }
  .auto{
    text-align: center;
    margin-top: 12px;
    color: #666666;
    line-height: 16px;
  }
  /deep/.van-dialog__header {
    padding: 0;
  }
  /deep/.van-dialog__content {
    padding: 27px 11px;
    background: #fff;
    border-radius: 12px;
    color: #302b3e;
  }
  /deep/.van-dialog__footer{
    display: flex;
    flex-direction: column-reverse;
    background: transparent;
    margin-top: 30px;
    .van-dialog__confirm{
      height: 40px;
      width: calc(100vw - 110px);
      margin: 0 auto;
      background: #ffb600;
      border-radius: 40px;
      font-size: 16px;
      color: #302b3e;
      line-height: 20px;
      text-align: center;
      line-height: 40px;
    }
    .van-dialog__cancel{
      text-align: center;
      margin-top: 22px;
      color: #666666;
      font-size: 16px;
      background: transparent;
    }
  }
  /deep/.van-hairline--top {
    &::after {
      border-top-width: 0;
    }
  }
}
</style>
